import { AnyAction, Middleware, MiddlewareAPI, Dispatch } from 'redux';
import ActionTypes from '../../../constants/ActionTypes';
import { PaymentOptionsType } from '../../../constants/PaymentOptions';
import AnalyticsMiddlewareProxy from './AnalyticsMiddlewareProxy';
import AnalyticsMiddlewareGA4MobProxy from './ga4/AnalyticsMiddlewareGA4MobProxy';
import AnalyticsMiddlewareGA4Proxy from './ga4/AnalyticsMiddlewareGA4Proxy';

export const gtmMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  const state = store.getState();

  switch (action.type) {
  case ActionTypes.ANALYTICS.DEVICE_IMPRESSIONS:
    AnalyticsMiddlewareGA4Proxy.viewItemList(state, action.payload);
    AnalyticsMiddlewareGA4MobProxy.viewDeviceList(state, action.payload);
    break;
  case ActionTypes.ANALYTICS.DEVICE_CLICK_FROM_LIST:
    AnalyticsMiddlewareGA4Proxy.selectItem(state, action.payload);
    AnalyticsMiddlewareGA4MobProxy.selectDevice(state, action.payload);
    break;
  case ActionTypes.ANALYTICS.DEVICE_OVERVIEW:
    AnalyticsMiddlewareGA4Proxy.viewItem(state);
    AnalyticsMiddlewareGA4MobProxy.viewDevice(state);
    break;
  case ActionTypes.ANALYTICS.DEVICE_OVERVIEW_PLAN_CHANGE:
    break;
  case ActionTypes.ANALYTICS.ADD_TO_BASKET:
    AnalyticsMiddlewareGA4MobProxy.addToCart(state);
    AnalyticsMiddlewareProxy.addToBasket(state);

    AnalyticsMiddlewareGA4Proxy.addToCart(state);
    AnalyticsMiddlewareGA4Proxy.beginCheckout(state);
    break;
  case ActionTypes.ANALYTICS.VIEW_CART:
    AnalyticsMiddlewareGA4Proxy.viewCart(state);
    AnalyticsMiddlewareGA4MobProxy.checkoutStep(
      state,
      action.payload.orderType,
      action.payload.stepName,
      action.payload.previousSteps
    );
    break;
  case ActionTypes.ANALYTICS.JUST_VIEW_CART:
    AnalyticsMiddlewareGA4MobProxy.viewCart(state);
    break;
  case ActionTypes.ANALYTICS.CAMPAIGN_VIEW_CART:
    AnalyticsMiddlewareGA4MobProxy.viewCampaignCart(state);
    break;
  case ActionTypes.ANALYTICS.P2PDJ_STEP:
    AnalyticsMiddlewareGA4MobProxy.campaignP2pDjStep(state, action.payload);
    break;
  case ActionTypes.ANALYTICS.P2PDJ_PURCHASE:
    AnalyticsMiddlewareGA4MobProxy.campaignP2pDjPurchase(state);
    break;
  case ActionTypes.ANALYTICS.NEXT_CHECKOUT_STEP:
    AnalyticsMiddlewareGA4MobProxy.checkoutStep(
      state,
      action.payload.orderType,
      action.payload.stepName,
      action.payload.previousSteps
    );
    break;
  case ActionTypes.ANALYTICS.EMPTY_CART:
    AnalyticsMiddlewareGA4Proxy.removeFromCartAll(state);
    break;
  case ActionTypes.ANALYTICS.SELECT_PAYMENT_OPTION:
    AnalyticsMiddlewareProxy.selectPaymentOption(state, action.payload.paymentOption as PaymentOptionsType);
    AnalyticsMiddlewareGA4Proxy.selectPaymentOption(state, action.payload.paymentOption as PaymentOptionsType);
    break;
  case ActionTypes.ANALYTICS.ADD_SHIPPING_INFO:
    AnalyticsMiddlewareGA4Proxy.addShippingInfo(state, action.payload.shippingTier);
    break;
  case ActionTypes.ANALYTICS.SUBMIT_ORDER:
    break;
  case ActionTypes.ANALYTICS.PURCHASE:
    AnalyticsMiddlewareGA4Proxy.purchase(state);
    AnalyticsMiddlewareGA4MobProxy.checkoutStep(
      state,
      action.payload.orderType,
      action.payload.stepName,
      action.payload.previousSteps
    );
    break;
  case ActionTypes.ANALYTICS.REFUND:
    AnalyticsMiddlewareGA4Proxy.refund(state);
    break;
  case ActionTypes.ANALYTICS.CANCEL_ORDER:
    AnalyticsMiddlewareGA4MobProxy.cancelOrder(state);
    break;
  case ActionTypes.ANALYTICS.VIEW_PROMOTION:
    AnalyticsMiddlewareGA4Proxy.viewPromotion(state, action.payload.details, action.payload.items);
    break;
  case ActionTypes.ANALYTICS.SELECT_INSURANCE:
    AnalyticsMiddlewareGA4Proxy.selectInsurance(state, action.payload.items);
    AnalyticsMiddlewareGA4MobProxy.selectInsurance(state, action.payload.items);
    break;
  case ActionTypes.ANALYTICS.TOPUP_STEP:
    AnalyticsMiddlewareGA4Proxy.topupStep(state, action.payload.data);
    break;
  case ActionTypes.ANALYTICS.PPR_INTERACTION:
    AnalyticsMiddlewareGA4Proxy.pprInteraction(state, action.payload.eventName, action.payload.contentData);
    break;
  case ActionTypes.ANALYTICS.CHOOSE_PACKAGE:
    AnalyticsMiddlewareGA4MobProxy.choosePackage(state, action.payload);
    break;
  case ActionTypes.ANALYTICS.SUBMIT_CAMPAIGN_CHOICE:
    AnalyticsMiddlewareGA4MobProxy.submitCampaignChoice(state, action.payload);
    break;
  case ActionTypes.ANALYTICS.CAMPAIGN_CONFIRMATION:
    AnalyticsMiddlewareGA4MobProxy.campaignConfirmation(state, action.payload);
    break;
  case ActionTypes.ANALYTICS.ORDER_CANCELED:
    AnalyticsMiddlewareGA4MobProxy.orderCanceled(state);
    break;
  case ActionTypes.ANALYTICS.ACESSORY_GO_TO_CHECKOUT:
    AnalyticsMiddlewareGA4MobProxy.acessoryGoToCheckout(state);
    break;
  default:
    break;
  }
};
